import Typography from "@mui/material/Typography";
import { FC } from "react";
import { StyledDetailsItem, StyledDetailsTitle } from "./styled";
import { COLOR_GREY_9, COLOR_BLACK } from "shared/theme/colors";

export type DetailsItemProps = {
  title: string;
  value?: string | number;
};

const DetailsItem: FC<DetailsItemProps> = (props) => (
  <StyledDetailsItem>
    <StyledDetailsTitle>
      <Typography variant="bodyMRegular" color={COLOR_GREY_9}>
        {props.title}
      </Typography>
    </StyledDetailsTitle>
    <Typography variant="bodyMRegular" color={COLOR_BLACK} ml="1rem">
      {props.value}
    </Typography>
  </StyledDetailsItem>
);

export default DetailsItem;
